import React from 'react';
import { View } from 'react-native-web';
import {
  Android,
} from '../../../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import LaunchFirstTimeMessageFP from '../FullPagesComponents/Interaction/LaunchFirstTimeMessageFP';

//= ========================================================================
const LaunchKeyboardDF = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs,
}) => {
  const { keyboard } = globJSON.configurations.launch;

  const showRightPhone = simPlatform !== Android && (slideshowRefs === null || keyboard.access_to_bank_info_message);

  return (
    <SimulatorsViewerArrangement>
      <View>
        {showRightPhone && (
        <LaunchFirstTimeMessageFP
          globJSON={globJSON}
          language={language}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
        />
        )}
        {!showRightPhone || (!keyboard.access_to_bank_info_message && (
        <View
          style={{
            width: 240,
            height: simPlatform === Android ? 427 : 520,
            marginTop: 20,
            position: 'absolute',
            backgroundColor: '#fff',
            opacity: 0.5,
          }}
        />
        ))}
      </View>
    </SimulatorsViewerArrangement>
  );
};

export default LaunchKeyboardDF;
